import React from 'react';
import { FormStateContext } from '@/contexts/FormStateContext';
import { TagSelector } from './TagSelector';

export const FormStateTagInput = ({ enableCreateTag }) => {
  const { state: formState, setFormStateValue } = React.useContext(FormStateContext);
  const { tags: value } = formState;

  const onChange = (value) => {
    setFormStateValue('tags', value);
  };

  return <TagSelector tags={value} onChange={onChange} enableCreateTag={enableCreateTag} />;
};
